import { IUserDeleteResponse } from "./user-delete.interface";
import { REMOVE_USER } from "./user-delete.mutation";
import { toastMessageActions } from "../../state/request";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useMutation } from "@apollo/client";

export const useUserDelete = () => {
  const dispatch = useDispatch();
  const [removeUserByEmail, { data, loading }] = useMutation<{ removeUserByEmail: IUserDeleteResponse }>(REMOVE_USER);

  const userDelete = (email: string) => {
    removeUserByEmail({
      variables: { email },
    });
  };

  useEffect(() => {
    dispatch(toastMessageActions.setGlobalLoading(loading));
  }, [loading]);

  return {
    userDeleted: data?.removeUserByEmail,
    userDelete,
  };
};
